<template>
  <div class="load-more-wrapper">
    <button
      ref="button"
      :class="`load-more-pill ${pillColorClass}`"
      :disabled="loading"
      @click="loadMore"
    >
      <span v-if="loading">{{ labels.EXPLORER.LOADING }}</span>
      <span v-else>{{ labels.EXPLORER.LOAD_MORE }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import labels from '@/translations/labels.json'
  import { useBaseStore } from '@/stores'

  const WHITE = '#FFFFFF'
  const BLACK = '#000000'

  const props = defineProps({
    pillBackgroundColor: { type: String, required: true },
  })

  const button = ref()
  const loading = ref(false)
  const baseStore = useBaseStore()

  const pillColorClass = computed((): string => {
    if (props.pillBackgroundColor === WHITE) {
      return 'load-more-pill-colors-inverted'
    } else if (props.pillBackgroundColor === BLACK) {
      return 'load-more-pill-colors'
    }

    return ''
  })

  function loadMore() {
    loading.value = baseStore.loadingState
  }
</script>

<style scoped lang="scss">
  .load-more-wrapper {
    display: flex;
    justify-content: center;
    margin: 0;
  }

  .load-more-pill-colors {
    background-color: #000000;
    color: #ffffff;
  }

  .load-more-pill-colors-inverted {
    background-color: #ffffff;
    color: #000000;
  }

  .load-more-pill {
    font-family: 'Roboto', sans-serif;
    border: none;
    border-radius: 15px;
    padding: 9px 26px;
    box-sizing: border-box;
    font-size: 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    text-align: center;
    justify-content: center;
  }

  .load-more-pill.loading {
    cursor: progress;
    padding: 9px 28px;
  }
</style>
